import { theme } from "@/theme";
import { LocalShipping } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import ModalAsnDetails from "../Modal/ModalAsnDetails";
import { AdvancedShippingNotice } from "@/common/AdvancedShippingNotice";
import { Transfer } from "@/common/Transfer";

export type AsnDetailsModalProps = {
	asns?: AdvancedShippingNotice[];
	isModalAsnDetailsOpen?: boolean;
	onAsnDetailsModalOpen?: () => void;
	onAsnDetailsModalClose?: () => void;
};

export type AsnButtonProps = {
	isOpen: boolean;
	asns: AdvancedShippingNotice[];
	transfer?: Transfer;
	fromLocationId?: string;
	fromLocationName?: string;
	toLocationId?: string;
	toLocationName?: string;
	onAsnDetailsModalOpen: () => void;
	onAsnDetailsModalClose: () => void;
};

export default function AsnButton(props: AsnButtonProps) {
	const { isOpen, asns, transfer, fromLocationId, fromLocationName, toLocationId, toLocationName, onAsnDetailsModalOpen, onAsnDetailsModalClose } = props;

	return (
		<>
			<IconButton
				onClick={onAsnDetailsModalOpen}
				style={{
					marginRight: theme.spacing(1),
					marginTop: "2px",
					flexShrink: 0,
					padding: 4,
				}}
			>
				<LocalShipping />
				<Typography
					variant="subtitle1"
					style={{
						fontWeight: "bold",
						paddingLeft: 4,
					}}
				>
					ASNs
				</Typography>
			</IconButton>
			<ModalAsnDetails
				isOpen={isOpen}
				asns={asns}
				transfer={transfer}
				fromLocationId={fromLocationId}
				fromLocationName={fromLocationName}
				toLocationId={toLocationId}
				toLocationName={toLocationName}
				onAsnDetailsModalClose={onAsnDetailsModalClose}
			/>
		</>
	);
}
